/**
 * Dev-only logger — suppresses all output in production builds.
 * Usage: import { devLog } from '@/utils/logger';
 *        devLog('message', error.message);
 */
const isDev = process.env.NODE_ENV === 'development';

export const devLog = isDev ? console.debug.bind(console) : () => {};
export const devWarn = isDev ? console.warn.bind(console) : () => {};
